import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  ModalController,
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { chevronUpSharp, chevronDownSharp, backspaceSharp, eyeSharp } from 'ionicons/icons';
import { PuzzleUpdateNotificationsModel } from '../../store/puzzle-update-notifications.model';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizedDatePipe } from 'projects/tools/src/lib/shared-module/helpers/localized-date.pipe';

@Component({
  selector: 'lib-puzzle-update-notification-modal',
  templateUrl: './puzzle-update-notification-modal.component.html',
  styleUrls: ['./puzzle-update-notification-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    IonButton,
    IonCol,
    IonContent,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonRow,
    IonText,
    IonTitle,
    IonToolbar,
    LocalizedDatePipe,
  ],
})
export class PuzzleUpdateNotificationModalComponent implements OnInit {
  // @Select(state => state.puzzleUpdateNotifications.updateNotifications) updateNotifications$: Observable<PuzzleUpdateNotification[]>;
  // updateNotifications: PuzzleUpdateNotification[] = [];

  triggeredUnreadAccordions: boolean[] = [];
  triggeredReadAccordions: boolean[] = [];

  @Select((state) => state.puzzleUpdateNotifications)
  puzzleUpdateNotifications$: Observable<PuzzleUpdateNotificationsModel>;
  puzzleUpdateNotifications: PuzzleUpdateNotificationsModel;

  constructor(
    public device: DeviceDetectorService,
    private ionicModal: ModalController,
    private framework: PuzzleFrameworkService
  ) {
    addIcons({
      chevronUpSharp,
      chevronDownSharp,
      backspaceSharp,
      eyeSharp,
    });
  }

  ngOnInit(): void {
    this.puzzleUpdateNotifications$.subscribe((updateNotifications) => {
      this.puzzleUpdateNotifications = updateNotifications;
    });
  }

  async closeDialog(markAsRead: boolean) {
    if (markAsRead) {
      await this.framework.markUpdateNotificationsAsRead();
    }
    await this.ionicModal.dismiss();
  }
}
